<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true }" (click)="toggleOpen()">
        <span class="margin-right">Owner and Well</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Owner Number:
      @if (fieldHasNotes('ownerWellInfo|ownerNumber') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|ownerNumber'" [notes]="getFilteredNotes('ownerWellInfo|ownerNumber')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="ownerNumber" />

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Owner Name:
      @if (fieldHasNotes('ownerWellInfo|ownerName') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|ownerName'" [notes]="getFilteredNotes('ownerWellInfo|ownerName')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="ownerName" />

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      API Number:
      @if (fieldHasNotes('ownerWellInfo|apiNumber') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|apiNumber'" [notes]="getFilteredNotes('ownerWellInfo|apiNumber')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="apiNumber" />

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Well Name:
      @if (fieldHasNotes('ownerWellInfo|wellName') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|wellName'" [notes]="getFilteredNotes('ownerWellInfo|wellName')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="wellName" />

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Well Number:
      @if (fieldHasNotes('ownerWellInfo|wellNumber') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|wellNumber'" [notes]="getFilteredNotes('ownerWellInfo|wellNumber')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="wellNumber" />

    </div>


    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Surface Latitude:
      @if (fieldHasNotes('ownerWellInfo|surfaceLat') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|surfaceLat'" [notes]="getFilteredNotes('ownerWellInfo|surfaceLat')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="number" formControlName="surfaceLat" />

    </div>



    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Surface Longitude:
      @if (fieldHasNotes('ownerWellInfo|surfaceLong') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|surfaceLong'" [notes]="getFilteredNotes('ownerWellInfo|surfaceLong')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="number" formControlName="surfaceLong" />

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      County:
      @if (fieldHasNotes('ownerWellInfo|county') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|county'" [notes]="getFilteredNotes('ownerWellInfo|county')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="county" />

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Township:
      @if (fieldHasNotes('ownerWellInfo|township') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|township'" [notes]="getFilteredNotes('ownerWellInfo|township')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="township" />

    </div>
    <div class="cell small-3 medium-3 large-3">
      &nbsp;
    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Quadrangle:
      @if (fieldHasNotes('ownerWellInfo|quadrangle') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|quadrangle'" [notes]="getFilteredNotes('ownerWellInfo|quadrangle')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="quadrangle" />

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Section:
      @if (fieldHasNotes('ownerWellInfo|section') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|section'" [notes]="getFilteredNotes('ownerWellInfoo|section')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="section" />

    </div>
    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Lot:
      @if (fieldHasNotes('ownerWellInfo|lot') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|lot'" [notes]="getFilteredNotes('ownerWellInfoo|lot')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="lot" />

    </div>
    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Tract:
      @if (fieldHasNotes('ownerWellInfo|sectLotTract') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|tract'" [notes]="getFilteredNotes('ownerWellInfoo|tract')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="tract" />

    </div>


    <div class="cell small-7 large-7 medium-7 bold">
      Type Of Well:
      @if (fieldHasNotes('ownerWellInfo|typeOfWell') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'ownerWellInfo|typeOfWell'" [notes]="getFilteredNotes('ownerWellInfo|typeOfWell')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">
      <input type="text" formControlName="typeOfWell" />
    </div>


    @if (fieldHasNotes('ownerWellInfo|wellNotDrilled') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'ownerWellInfo|wellNotDrilled'" [notes]="getFilteredNotes('ownerWellInfo|wellNotDrilled')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
    <div class="checkbox padding-left">
      <input class="show-for-sr" id="wellNotDrilled" type="checkbox" formControlName="wellNotDrilled" (change)="onWellNotDrilledChecked($event)" />
      <label for="wellNotDrilled" class="bold">
        Well is not drilled:
        <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
      </label>
    </div>
  </div>
</ng-container>
